import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsProductsLabel extends Component{ 

    constructor(props){
      super(props);

      this.state={
          productlabels:[],
          modalTitle:"",
          productlabelname:"",
          productlabelid:0,

          ProductLabelIdFilter:"",
          ProductLabelNameFilter:"",
          productlabelsWithoutFilter:[],
          productlabelNames: [],
          productlabelExists: false, 
      }
  }

  FilterFn(){
    var ProductLabelIdFilter=this.state.ProductLabelIdFilter;
    var ProductLabelNameFilter = this.state.ProductLabelNameFilter;

    var filteredData=this.state.productlabelsWithoutFilter.filter(
        function(el){
            return el.productlabelid.toString().toLowerCase().includes(
                ProductLabelIdFilter.toString().trim().toLowerCase()
            )&&
            el.productlabelname.toString().toLowerCase().includes(
                ProductLabelNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({productlabels:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.productlabelsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({productlabels:sortedData});

}

changeProductLabelIdFilter = (e)=>{
  this.state.ProductLabelIdFilter=e.target.value;
  this.FilterFn();
}
changeProductLabelNameFilter = (e)=>{
  this.state.ProductLabelNameFilter=e.target.value;
  this.FilterFn();
}

refreshList(){
  axiosService.get('/productlabels/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({productlabels:data,productlabelsWithoutFilter:data});
  });
}


fetchProductlabelNames() {
  axiosService.get('/productlabels/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const productlabelNames = data.map(item => item.productlabelname);
      this.setState({ productlabelNames: productlabelNames });
    })
    .catch(error => {
      console.error("Error fetching productlabel names:", error);
    });
}

checkProductlabelExists = (event) => {
  const enteredProductlabel = event.target.value.toLowerCase(); // Convert to lowercase
  const { productlabelNames } = this.state;
  const productlabelExists = productlabelNames.some((productlabel) => productlabel.toLowerCase() === enteredProductlabel);
  this.setState({ productlabelExists });
};


componentDidMount(){
  this.refreshList();
  this.fetchProductlabelNames();
}

changeProductLabelName =(e)=>{
  this.setState({productlabelname:e.target.value});
}

addClick(){
  this.setState({
      modalTitle:"Add ProductLabel",
      productlabelid:0,
      productlabelname: "",
      productlabelExists: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit ProductLabel",
      productlabelid:dep.productlabelid,
      productlabelname:dep.productlabelname,
      initialProductlabelname:dep.productlabelname,
      productlabelExists: false,
  });
}

createClick() {
  const { productlabelname, productlabelNames } = this.state;

  if (!productlabelname) {
    alert('Product Label Name is required');
    return;
  }

  
  if (productlabelNames.some(name => name.toLowerCase() === productlabelname.toLowerCase())) {
    alert('Productlabel already exists. Please provide a unique Productlabel Name.');
    return;
  }
  

  axiosService.post('/productlabels/', {
    productlabelname: productlabelname
  })
    .then(result => {
      alert('ProductLabel created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){

  const { productlabelname, initialProductlabelname, productlabelNames } = this.state;

     // Check if any changes are detected
     if (
      productlabelname === initialProductlabelname
    ) {
      alert('No changes detected');
      return;
    }

    
  if (
    productlabelNames.some(
      (existingProductlabel) =>
        existingProductlabel.toLowerCase() === productlabelname.toLowerCase()
    )
  ) {
    alert('Productlabel already exists. Please provide a unique Productlabel Name.');
    return;
  }


  if (!productlabelname) {
    alert('Product Label Name is required');
    return;
  }


  axiosService.patch('/productlabels/'+id+'/',{
      productlabelid:this.state.productlabelid,
      productlabelname:this.state.productlabelname
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/productlabels/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      productlabels,
      modalTitle,
      productlabelid,
      productlabelname,
      productlabelExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductLabelIdFilter}
      placeholder="Filter"/>
      

      </div>
      ProductLabelId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductLabelNameFilter}
      placeholder="Filter"/>
      </div>
      ProductLabel

  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {productlabels.map(dep=>
      <tr key={dep.productlabelid} className="row-hover">
          <td className="table-text">{dep.productlabelid}</td>
          <td className="table-text">{dep.productlabelname}</td>
          <td className="table-text">
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Productlabel</span>
          <input
            type="text"
            className={`form-control ${productlabelExists ? "is-invalid" : ""}`}
            value={productlabelname}
            onChange={this.changeProductLabelName}
            onBlur={this.checkProductlabelExists}
            style={{ fontSize: "12px" }} 
          />
          {productlabelExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >Product Label already exists.</div>}
        </div>

        {productlabelid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {productlabelid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(productlabelid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }

